import { connect } from 'react-redux';
import TeamMembersPage from '../TeamMembersPage';
import { checkPermission, onLoggedIn, loadGroups, checkPlanPermission } from '../../../utils/ProfileHelpers';
import { getColumns, getFormattedDivisions } from '../../../redux/selectors/team';
import {
  setAction,
  getMembersAction,
  updateUsersGroupAction,
  updateDivisionMembersAction,
  getDivisionMembersAction,
  deleteTeamUsersAction,
} from '../actions/teamMembersPage';

const mapStateToProps = (state) => {
  return {
    paths: state.app.paths || {},
    team: state.profile.team,
    groups: state.profile.groups,
    division: state.profile.division,
    divisions: state.profile.divisions,
    dataReturned: state.teamMembersPage.dataReturned,
    activeDivision: state.teamMembersPage.activeDivision,
    members: state.teamMembersPage.members,
    editDivisionModalOpen: state.teamMembersPage.editDivisionModalOpen,
    page: state.teamMembersPage.page,
    pageSize: state.teamMembersPage.pageSize,
    pageCount: state.teamMembersPage.pageCount,
    checkPermission: (permission) => checkPermission(permission, state.profile),
    reloadTeams: onLoggedIn,
    columns: getColumns(),
    loadGroups: loadGroups,
    checkPlanPermission: (permission) => checkPlanPermission(permission, state.profile),
    formattedDivisions: getFormattedDivisions(state.profile),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMembers: (team, page, pageSize) => dispatch(getMembersAction({ team, page, pageSize })),
  updateUsersGroup: (team, row, page, pageSize) => dispatch(updateUsersGroupAction({ team, row, page, pageSize })),
  updateDivisionMembers: (team, activeDivision, members, checkboxValues, page, pageSize) =>
    dispatch(updateDivisionMembersAction({ team, activeDivision, members, checkboxValues, page, pageSize })),
  getDivisionMembers: (team, division, page, pageSize, members) =>
    dispatch(getDivisionMembersAction({ team, division, page, pageSize, members })),
  deleteTeamUsers: (team, users, page, pageSize) => dispatch(deleteTeamUsersAction({ team, users, page, pageSize })),
  set: (params) => dispatch(setAction(params)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(TeamMembersPage);
